<template>
    <div class="attend_wrap">
        <div class="attend_hd">
            <h2 class="title">
               <div> <font-awesome-icon icon="calendar-alt" /> 출석부</div>
            </h2>

            <div class="today_mission" style="height:auto;">
                <div class="tip">
                   
                    <p v-if="pointRule">출석체크하시면  {{givepoint().point}} 포인트가 지급됩니다.</p>
                </div>
                <div class="mission">
                </div>
            </div>
            <div class="calendar_area">
                <div>

                </div>
            </div>

        </div>
        <div  class="attend_bd">
            <div class="at_input_wrap">
                <div class="info_area">
                    <dl>
                        <dt>개근 보너스 포인트&nbsp;:&nbsp;</dt>
                        <dd>
                            <a class="btn_detail" href="javascript:;">자세히보기</a>
                            <ul style="display:none">
                                <li><strong>10일</strong> 1,000P</li>
                                <li><strong>20일</strong> 2,000P</li>
                                <li><strong>30일</strong> 3,000P</li>
                            </ul>
                        </dd>
                    </dl>
                </div>
                <div id="at_input" class="input_area">
                    <input type="hidden" name="is_login" value="false">
                    <dl class="attend_before">
                        <dd class="clfix">
                            <input class="attend_input" type="text" placeholder="30글자 이내로 출석 인사말을 입력후 출석버튼을 클릭해주세요." autocomplete="off"
                                @click="ckLogin()" v-model.trim="content" id="attend_input"
                            >
                            <div>
                                <base-button mode="red_sm" @click="attendance()">
                                    출석체크
                                </base-button>
                            </div>
                        </dd>
                    </dl>
                    <p class="tip clfix">
                        <span class="tx"><font-awesome-icon icon="exclamation-circle" /> 출석체크 인사말 입력시 욕설이나, 비방 또는 홍보성 인사글 입력시 제재를 받을 수 있습니다.</span>
                    </p>
                </div>
            </div>

            <div class="at_table_area">
                <div class="summary_area">
                    <form id="formAttendList" action="./list.ajax.php" onsubmit="return submitList(this);" method="post">
                        <input type="hidden" name="date" value="0">
                        <input type="hidden" name="order" value="time">
                        <input type="hidden" name="page" value="1">
                    </form>
                    <div class="select_time select">
                        <select  @change="selectSort" v-model="sort">
                            <option value="created_at">시간순</option>
                            <!-- <option value="result_point">순위순</option> -->
                            <option value="point">포인트</option>
                            <option value="continuity">개근</option>
                        </select>

                    </div>
                    <div class="select_day select">
                        <select  @change="selectDate" v-model="select_day">
                            <option value=0>오늘</option>
                            <option :value="index+1" v-for="(n, index) in 7" :key="index">{{index+1}}일전</option>
                        </select>
                    </div>
                </div>

                 <div class="at_board_list">
                     <table>
                        <colgroup>
                            <col width="44px;">
                            <col width="100px;">
                            <col width="">
                            <col width="130px;">
                            <col width="70px;">
                            <col width="55px;">
                        </colgroup>
                         <thead>
                             <tr>
                                <th>순위</th>
                                <th>출석시간</th>
                                <th>출석인사</th>
                                <th>닉네임</th>
                                <th>포인트</th>
                                <th>개근</th>
                             </tr>
                         </thead>
                         <tbody v-if="attendancelists">
                            <template v-if="attendancelists.length ===0">
                                <tr><td colspan="6">아직 출석체크한 유저가 없습니다.</td></tr>
                            </template>
                            <template v-else>
                                 <tr v-for="(list, index) in attendancelists" :key="index">
                                    <td>{{ attendancelists.length-index }}</td>
                                    <td> <display-time :time="list.created_at"/></td>
                                    <td>{{ list.content }}</td>
                                    <td>{{ list.user.nic }}</td>
                                    <td class="point">{{ list.point }}</td>
                                    <td>{{ list.continuity }}</td>
                                </tr>
                            </template>
                         </tbody>
                     </table>
                 </div>
            </div>
        </div>
    </div>
</template>
<script>
import DisplayTime from '@/components/site/parts/DisplayTime.vue'
export default {
    data(){
        return{
            content:'',
            pointRule:'',
            sort:'created_at',
            select_day:'0'
        }
    },
    components:{
        DisplayTime
    },
    computed:{
        attendancelists:{
            get(){
                //console.log('포스터 데이터 넘어오는 형식 보기',this.$store.state.attendance.attendancelists)
                return this.$store.state.attendance.attendancelists;
            }
        },
        isAuth() {
            return this.$store.getters.isAuthenticated;
        },
      
    },
    methods: {
        selectDate(event){
            console.log(event.target.value)
            this.select_day = event.target.value;
            this.fetchLists();
        },
        selectSort(event){
            console.log(event.target.value)
            this.sort = event.target.value;
            this.fetchLists();
        },
        givepoint()
        {
            return this.pointRule.find((point)=>point.name ==="attendance1");    
        },
        attendance()
        {
            if(this.content ==="")
            {
                alert('내용을 입력 해 주세요');
                document.querySelector("#attend_input").focus();
                return;
            }
            this.submitform();
            this.content='';
        },
        ckLogin(){
            if(!this.isAuth)
            {
                let result = confirm("로그인이 필요합니다.");
                if(result){
                    //this.$router
                    this.$router.push({ name: 'auth_login'});
                    return;
                }else{
                    return;
                }
            }
        },
        async fetchLists() {
            const formData = {
                content:this.content,
                user_id:this.$store.getters.currentUser.id,
                sort: this.sort,
                select_day:this.select_day,
                page:1
            }
            try {
                const response = await this.$store.dispatch("attendance/fetchLists", formData)
                console.log(response);
                this.attendancelists = response.attendance.data;
                this.pointRule = response.points;
                //console.log(response.points);
                //console.log("안나오는듯",this.postlists.data.length);
            }catch(error){
                console.log(error.response);
            }
                this.isLoading = false;
        },
        async submitform() {
            const formData = {
                content:this.content,
                user_id:this.$store.getters.currentUser.id,               
                page:1
            }
            try {
                const response = await this.$store.dispatch("attendance/registerAttendance", formData)
                console.log(response);
                //console.log("안나오는듯",this.postlists.data.length);
                if(response.attendance!==0)
                {
                    //this.$store.commit('updateUserPoint',response.attendance.point)
                   this.$store.commit('updateUserPoint',response.user);    
                    if(response.levelchange)
                    {
                    alert('레벨이 변경되었습니다.');
                    }  
                }
                this.$flashMessage.show({
                    type: response.attendance===0?"error":"info",
                    title: response.message,
                    message: response.message,
                    //
                });
            }catch(error){
                console.log(error.response);
            }
                this.isLoading = false;

        },
    },
    mounted(){
        this.fetchLists();
    }
}
</script>
<style lang="scss" scoped>
.attend_wrap{
    .attend_hd{
        border: 1px solid #d6d6d6;
        margin-bottom: 5px;
        background-color: #fff;
        height: auto;
        font-family: 맑은 고딕;
        .title{
            height: 71px;
            border-bottom: 1px solid #f4f4f4;
            background-color: #fcfcfc;
            margin: 0;
            color:#666;
            padding:20px;
        }
        .today_mission{
            padding: 18px 0 0 20px;
            border-bottom: 1px solid #f4f4f4;
            .tip{
                margin-bottom: 16px;
            }
        }
    }
    .attend_bd{
        .at_input_wrap{
            margin-bottom: 5px;
            border: 1px solid #d6d6d6;
            background-color: #fff;
            .info_area {
                padding: 18px 0 0 20px;
                height: 33px;
                border-bottom: 1px solid #f4f4f4;
                box-sizing: content-box;
                dl {
                    float: left;
                    position: relative;
                    margin-right: 20px;
                    line-height: 15px;
                }
                dt{float: left;}
                dd{
                    float: left;
                    font-weight: 700;
                    a {
                        color: #1287eb;
                    }
                }
                ul {
                    position: absolute;
                    padding: 10px;
                    border: 1px solid #d6d6d6;
                    background-color: #fcfcfc;
                    li {
                        line-height: 15px;
                        font-weight: 400;
                        color: #333;
                        white-space: nowrap;
                    }
                }
            }
            .input_area {
                margin: 20px auto 0;
                width: 788px;
                .clfix{
                    display:flex;
                    .attend_input {
                        margin-right: 1px;
                        padding: 0 10px;
                        width: 679px;
                        height: 31px;
                        border: 1px solid #d6d6d6;
                    }
                }

                .tx{
                    color: #a3a3a3;
                    line-height: 15px;
                }
            }
        }
        .at_table_area{
            .summary_area{
                margin-bottom: 5px;
                height: 33px;
                .select {
                    position: relative;
                    float: right;
                    margin-left: 1px;
                    margin-right: 1px;
                    height: 31px;
                    select{
                        height:31px;
                        width:100px;
                        border:1px solid #d6d6d6;
                    }

                }
            }
            .at_board_list{
                table{
                    width: 100%;
                    background-color: #fff;
                    thead {
                        border: 1px solid #374151;
                        th {
                            height: 31px;
                            font-weight: 400;
                            background-color: #111827;
                            color: #fff;
                        }
                    }
                    tbody{
                        border: 1px solid #d6d6d6;
                         tr:first-child td {
                            border: none;
                        }
                        td{
                            text-align:center;
                            padding:10px;
                        }
                        .point{
                            font-weight:bold;
                            color:#81109D;
                        }
                    }
                }
            }
        }
    }
}
</style>
